import * as automatedLendingDecisionActions from './AutomatedLendingDecision.actions';
import {
    DE_AP_LOW_PROBABILITY,
    DE_AP_MEDIUM_PROBABILITY
} from './DEApprovalPropability/DEApprovalPropability';
import {
    CANCEL_GET_LOAN_DECISION,
    LOAN_DECISION_ERROR
} from '../LoanDecision/LoanDecision.actions';

const initialState = {
    step: null,
    errorCode: null,
    triggeredRedirectToDecision: false
};

export default function (state = initialState, action) {
    switch (action.type) {
        case automatedLendingDecisionActions.TAKE_TO_DECISION:
            return {
                ...state,
                triggeredRedirectToDecision: true
            };
        case automatedLendingDecisionActions.SHOW_CHECKING_APPLICATION:
            return {
                ...state,
                step: 'CHECKING_APPLICATION'
            };
        case LOAN_DECISION_ERROR:
            const errorCode = getErrorFromApplicationOffers(action.errorCode);
            return {
                ...state,
                step: 'ERROR',
                errorCode
            };
        case DE_AP_LOW_PROBABILITY:
        case DE_AP_MEDIUM_PROBABILITY:
            return {
                ...state,
                step: action.type
            };
        case 'SHOW_NOT_ELIGIBLE':
            return {
                ...state,
                step: 'NOT_ELIGIBLE'
            };
        case CANCEL_GET_LOAN_DECISION:
            return initialState;
        default:
            return state;
    }
}

export const COMPANY_NOT_FOUND_ERROR = 'companyNotFound';
export const DIRECTORS_COMPANY_MISMATCH_ERROR = 'directorsCompanyMismatch';
export const NO_DIRECTORS_ERROR = 'noDirectors';
export const INCOMPLETE_CREDIT_CHECK_ERROR = 'incompleteCreditCheck';
export const DUPLICATE_GUARANTORS_ERROR = 'duplicateGuarantors';
export const TECHNICAL_ERROR = 'technical';
export const SOLE_TRADER_ADDITIONAL_GUARANTORS =
    'soleTraderAdditionalGuarantors';
export const NO_AFFORDABILITY_ASSESSMENT = 'noAffordabilityAssessment';
export const COMPANY_DETAILS_INCORRECT = 'companyDetailsError';

export const KNOWN_ERROR_CODE_PRIORITY = {
    125: 1,
    137: 2,
    138: 2,
    134: 3,
    136: 4,
    141: 4
};

export const KNOWN_ERROR_CODES = Object.keys(KNOWN_ERROR_CODE_PRIORITY);

export function getErrorFromApplicationOffers(errorCode) {
    switch (errorCode) {
        case '125':
            return COMPANY_NOT_FOUND_ERROR;
        case '137':
            return DIRECTORS_COMPANY_MISMATCH_ERROR;
        case '138':
            return NO_DIRECTORS_ERROR;
        case '134':
            return INCOMPLETE_CREDIT_CHECK_ERROR;
        case '136':
            return DUPLICATE_GUARANTORS_ERROR;
        case '140':
            return SOLE_TRADER_ADDITIONAL_GUARANTORS;
        case '106':
        case '107':
            return NO_AFFORDABILITY_ASSESSMENT;
        case '141':
            return COMPANY_DETAILS_INCORRECT;
        default:
            return TECHNICAL_ERROR;
    }
}
